import React, {PropTypes} from 'react';
import QuestionList from './QuestionList';

const Search = ({
    q,
    questions,
    user,
    offset,
    limit,
    total,
    showMoreClick,
    widget = true,
    contextType,
}) => {
  let content;
  if (questions && questions.length) {
    content = <QuestionList questions={questions} user={user} widget={widget} />;
  } else {
    content = <h3>No search results</h3>;
  }

  const hasMore = questions && (total > offset + questions.length);
  const loadMoreQuestions = (e) => {
    e.preventDefault();
    showMoreClick(q, offset + limit, contextType);
  };

  const showMore = hasMore ? (
    <button className="t-home-show-more tes-btn tes-btn--secondary tes-btn--sm" onClick={loadMoreQuestions}>
      <span className="icon-text-container">
        <i className="icon-plus icon-light-gray" />
        Show more ...
      </span>
    </button>
  ) : null;

  return (
    <div>
      {content}
      {showMore}
    </div>
  );
};

Search.propTypes = {
  questions: PropTypes.array,
  q: PropTypes.string,
  user: PropTypes.object,
  tag: PropTypes.string,
  widget: PropTypes.bool,
  order: PropTypes.string,
  offset: PropTypes.number,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  orderClick: PropTypes.func.isRequired,
  showMoreClick: PropTypes.func.isRequired,
  showHomeClick: PropTypes.func.isRequired,
  contextType: PropTypes.string.isRequired,
};

export default Search;
